import { TabPanel, TabView } from "primereact/tabview";
import UiPageLayout from "../../components/page-layout/PageLayout.component";
import { useBiometrics } from "../../hooks/useBiometrics";
import { PageProps } from "../../models/routing.model";
import { getLocalStorageUser } from "../../services/session/auth.service";
import { useTranslation } from "react-i18next";
import TrackHealthState from "./TrackHealthState";
import { BiometricType } from "../../models/entities/biometrics.model";
import TrackHealthContent from "./TrackHealthContent";
import UiButton from "../../components/button/Button";
import { useNavigate } from "react-router-dom";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { MatomoAction, MatomoCategory } from "../../models/matomo.model";

const TrackHealth = (_props: PageProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();
	const matomo = useMatomo();

	const biometricsQuery = useBiometrics({ participantId: getLocalStorageUser().id });

	const setActiveTab = () =>
		biometricsQuery.data?.get(BiometricType.glucose)
			? 0
			: biometricsQuery.data?.get(BiometricType.blood_pressure)
				? 1
				: 2;

	return (
		<UiPageLayout
			title="TRACK_HEALTH.TITLE"
			className="track-health-container"
			leftChildren={
				<UiButton
					label="TRACK_HEALTH.BUTTON_HEALTH_REPORT"
					onClick={(_e) => {
						matomo.trackEvent({
							category: MatomoCategory.HEALTH_REPORT,
							action: MatomoAction.HEALTH_REPORT_TAB,
						});
						navigate("/health-report", { replace: true });
					}}
				/>
			}
			rightChildren={
				<>
					{biometricsQuery.data?.get(BiometricType.glucose) ||
						biometricsQuery.data?.get(BiometricType.blood_pressure) ||
						biometricsQuery.data?.get(BiometricType.weight) ? (
						<TabView activeIndex={setActiveTab()}>
							{/* Glucose */}
							{biometricsQuery.data?.get(BiometricType.glucose) && (
								<TabPanel header={t("TRACK_HEALTH.TAB_TITLE_GLUCOSE")}>
									<TrackHealthContent
										type={BiometricType.glucose}
										data={biometricsQuery.data.get(BiometricType.glucose)!}
									/>
								</TabPanel>
							)}

							{/* Blood pressure */}
							{biometricsQuery.data?.get(BiometricType.blood_pressure) && (
								<TabPanel header={t("TRACK_HEALTH.TAB_TITLE_BP")}>
									<TrackHealthContent
										type={BiometricType.blood_pressure}
										data={
											biometricsQuery.data.get(BiometricType.blood_pressure)!
										}
									/>
								</TabPanel>
							)}

							{/* Weight */}
							{biometricsQuery.data?.get(BiometricType.weight) && (
								<TabPanel header={t("TRACK_HEALTH.TAB_TITLE_WEIGHT")}>
									<TrackHealthContent
										type={BiometricType.weight}
										data={biometricsQuery.data.get(BiometricType.weight)!}
									/>
								</TabPanel>
							)}
						</TabView>
					) : (
						<TrackHealthState {...biometricsQuery} />
					)}
				</>
			}
		/>
	);
};
export default TrackHealth;
